export default "/images/vendor/flag-icon-css/flags/1x1/lr.svg?74dcec3fec3f73e24a0a362de1a2e496";